import * as tslib_1 from "tslib";
import store from '../../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getContextMenuFolders from './getContextMenuFolders';
import folderStore, { loadFoldersFromSessionData } from 'owa-folders';
/**
 * Makes the find folder service call and adds the folders to the create/edit inbox rule store
 */
export default action('initializeInboxRulesFolders')(select({
    optionState: function () { return store; },
})(function initializeInboxRulesFolders(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var junkFolderId;
        return tslib_1.__generator(this, function (_a) {
            loadFoldersFromSessionData();
            junkFolderId = folderNameToId('junkemail');
            state.optionState.contextMenuFolders = getContextMenuFolders();
            state.optionState.junkFolderDisplayName = folderStore.folderTable.get(junkFolderId).DisplayName;
            return [2 /*return*/];
        });
    });
}));
//# sourceMappingURL=initializeInboxRulesFolders.js.map